import React from 'react';
import { useToast } from 'react-native-toast-notifications';
import { Button } from '../../../components/Form';
import { Page, ToastType, showToast } from '../../../components';

export const DemoToast = () => {
  const toast = useToast();

  const myToast = (type: ToastType = 'normal') => {
    showToast(toast, { title: 'Implementation', message: 'For future use', type: type });
  };

  const save = () => {
    showToast(toast, { title: 'Saved!', message: 'Your data saved successfully', type: 'success' });
  };

  return (
    <Page title={'Demo - Toast'}>
      <Button onPress={() => myToast()}>Normal</Button>
      <Button onPress={() => myToast('success')}>Success</Button>
      <Button onPress={() => myToast('warning')}>Warning</Button>
      <Button onPress={() => myToast('error')}>Error</Button>
      <Button onPress={() => myToast('info')}>Info</Button>
      <Button onPress={save}>Saved</Button>
    </Page>
  );
};
